export default "__VITE_ASSET__8a313ac4__"